export default __webpack_public_path__ + "static/sweepstakes-grand-3-65d820b36674c0d5d4e2bf8d1279e5f1.jpg";